import { cloneDeep } from 'lodash';

import { DataChangeType } from '../../../helpers';

export class DataChange {
    changeId = 0;
    data = null;
    changeType = null;
    constructor(changeId, data, changeType) {
        this.changeId = changeId;
        this.data = cloneDeep(data);
        this.changeType = changeType;
    }
}

export class DataTransaction {
    _nextChangeId = 0;
    changes = null;
    constructor() {
        this._nextChangeId = 0;
        this.changes = [];
    }
    get hasPendingChanges() {
        return this.changes.length > 0;
    }
    setDataChange(changeId, data, changeType) {
        let dataChange = null;
        if (!changeId) {
            this._nextChangeId++;
            dataChange = new DataChange(this._nextChangeId, data, changeType);
            this.changes.push(dataChange);
            return dataChange;
        } else {
            const oldDataChange = this.changes.find(x => x.changeId === changeId);
            this.changes = this.changes.filter(x => x.changeId !== changeId);
            if (oldDataChange && oldDataChange.changeType === DataChangeType.AddNew) {
                if (changeType === DataChangeType.AddNew
                    || changeType === DataChangeType.Update) {
                    dataChange = new DataChange(changeId, data, DataChangeType.AddNew);
                    this.changes.push(dataChange)
                    return dataChange;
                }
            } else {
                dataChange = new DataChange(changeId, data, changeType);
                this.changes.push(dataChange)
                return dataChange;
            }
        }
    }
    removeDataChange(changeId) {
        this.changes = this.changes.filter(x => x.changeId !== changeId);
    }
    clone() {
        const clone = new DataTransaction();
        clone._nextChangeId = this._nextChangeId;
        clone.changes = cloneDeep(this.changes);
        return clone;
    }
}